var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "d-flex timeline__item" }, [
    _c("div", { staticClass: "mr-3 mt-4" }, [
      _c("div", { staticClass: "w-date-fixed" }, [_vm._t("date")], 2)
    ]),
    _c("div", { staticClass: "timeline__content w-100" }, [
      _c(
        "div",
        { staticClass: "timeline__content--inner p-4" },
        [
          _vm.icon || _vm.$slots["icon"]
            ? _c(
                "div",
                { staticClass: "icon-absolute" },
                [
                  _vm.$slots["icon"]
                    ? _vm._t("icon")
                    : _c("em", {
                        staticClass: "radius text-white",
                        class: _vm.icon
                      })
                ],
                2
              )
            : _vm._e(),
          _vm._t("default")
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }